import React, { Dispatch, SetStateAction } from 'react';
import { Grid } from '@material-ui/core';
import { MainButton, SimpleSelect, useFetch } from 'src/commons';
import { grey } from 'src/theme/colors';
import { DateClose } from 'src/app/components/inputs/Input/DateClose';
import { useFiltersLogic } from './hooks';
import { MainInput } from '../../../../../commons/components/MainInput';
import { useRolesContext } from '../../../../../context';
import { ORDER_STATES } from './const';
import { JoinedFilters } from './types';
import { useExportCsv } from '../../hooks/useExportCsv';



export type PromotionOperationHeaderProps = {
  filter: JoinedFilters;
  onChangeFilter: Dispatch<SetStateAction<JoinedFilters>>;
  loadingMore: boolean;
  orderLength: number
};

const titleStyle = {
  color: grey.medium,
  fontWeight: 'normal',
  verticalAlign: 'center',
};

export const PromotionOperationHeader = ({
  filter,
  onChangeFilter,
  loadingMore,
  orderLength
}: PromotionOperationHeaderProps) => {
  const { selectedRole } = useRolesContext();

  const { data: marketplaces, loading: loadingMarket } = useFetch('/marketplace');
  const { data: status, loading: loadingStatus } = useFetch('/operation/status');
  const { data: accounts, loading: loadingAccounts } = useFetch('/account');
  const { data: retails, loading: loadingRetails } = useFetch('/retail');
  // const { data: orderStates, loading: loadingOrderStates } = useFetch('/order/state');

  const props = {
    filter,
    onChangeFilter,
  };
  const {
    statusId,
    onStatusChange,
    marketplace,
    onMarketplaceChange,
    userId,
    onUserIdChange,
    search,
    onSearchChange,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    order_state_id,
    onOrderStateChange,
    retail,
    onRetailChange,
  } = useFiltersLogic(props);

  const { downloading, handleDownloadCsv } = useExportCsv({
    filter,
    statusId,
    marketplace,
    userId,
    search,
    startDate,
    endDate,
    order_state_id,
    retail,
  });

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        <Grid container spacing={1} alignItems="flex-end">
          <Grid item xs={12} sm={1}>
            <SimpleSelect
              value={statusId}
              placeholder="Estado"
              onChange={onStatusChange}
              content={status || []}
              valueKey="operation_order_state_id"
              labelKey="name"
              idValue="operation_order_state_id"
              loading={loadingStatus}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <SimpleSelect
              value={order_state_id}
              placeholder="Estado de Orden"
              onChange={onOrderStateChange}
              content={ORDER_STATES}
              valueKey="order_state_id"
              labelKey="name"
              idValue="order_state_id"
            />
          </Grid>

          <Grid item xs={12} sm={1}>
            <SimpleSelect
              value={userId}
              placeholder="Usuario"
              onChange={onUserIdChange}
              content={accounts || []}
              valueKey="account_id"
              labelKey="username"
              idValue="account_id"
              loading={loadingAccounts}
            />
          </Grid>
          <Grid item xs={12} sm={1}>
            <SimpleSelect
              value={retail}
              placeholder="Retail"
              onChange={onRetailChange}
              content={retails || []}
              valueKey="retail_id"
              labelKey="name"
              idValue="retail_id"
              loading={loadingRetails}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <DateClose name="Start Date" value={startDate} onChange={setStartDate} />
          </Grid>

          <Grid item xs={12} sm={2}>
            <DateClose name="End Date" value={endDate} minValue={startDate} onChange={setEndDate} />
          </Grid>

          <Grid item sm={2} container justify="flex-end">
            <Grid item sm={12} style={{ alignSelf: 'flex-start' }}>
              <MainInput
                type="search"
                handleChange={onSearchChange}
                placeholder="Buscar"
                name="search"
                value={search}
                fullWidth
                customStyleLabel={titleStyle}
                customStyle={{ height: 38.5 }}
              />
            </Grid>
          </Grid>
          <Grid item sm={2} container justify="flex-end">
            <Grid item sm={12} style={{ alignSelf: 'flex-start' }}>
              <MainButton
                customStyle={{ marginTop: 15, width: 170 }}
                title={`${downloading ? 'Descargando' : 'Descargar CSV'}`}
                disabled={downloading || loadingMore || orderLength === 0}
                type="primary"
                size="medium"
                handleOnClick={handleDownloadCsv}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
